package fr.labodoc.healthProfessional.webApp.data.model

data class LaboratoryModel(
  val id: String,
  val name: String,
  val websiteUrl: String,
  val logoUrl: String,
  val favorite: Boolean
)
